import { render, staticRenderFns } from "./TemplateKursListe.vue?vue&type=template&id=44594b24&"
import script from "./TemplateKursListe.vue?vue&type=script&lang=js&"
export * from "./TemplateKursListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports